import React from 'react';
import NoPage from './screens/NoPage';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import HomeScreen from './screens/HomeScreen';
import Navbar from './sections/Navbar';
import Footer from './sections/Footer';
import ServicesScreen from './screens/ServicesScreen';
import Blog1Screen from './screens/Blog1Screen';
import Blog2Screen from './screens/Blog2Screen';
import Blog3Screen from './screens/Blog3Screen';
// import { initGA, logPageView } from './utils/analytics';
import PrivacyPolicyScreen from './screens/PrivacyPolicy';
import TermsAndConditionsScreen from './screens/TermsAndConditions';
import PricingScreen from './screens/PricingScreen';
import BlogsScreen from './screens/BlogsScreen';
import ContactScreen from './screens/ContactScreen';
import AboutUsScreen from './screens/AboutUsScreen';
import RemoveServiceScreen from './screens/servicesScreens/RemoteServiceScreen';
import ContractServiceScreen from './screens/servicesScreens/ContractServiceScreen';
import CorporateServiceScreen from './screens/servicesScreens/CorporateServiceScreen';
import FaqScreen from './screens/FaqScreen';
import IPServiceScreen from './screens/servicesScreens/IPServiceScreen';
import LitigationServiceScreen from './screens/servicesScreens/LitigationServiceScreen';
import HRServiceScreen from './screens/servicesScreens/HRServiceScreen';
import DataPrivacyServiceScreen from './screens/servicesScreens/DataPrivacyServiceScreen';
import MergersServiceScreen from './screens/servicesScreens/MergersServiceScreen';
import FixedFeeLegalServiceScreen from './screens/servicesScreens/FixedFeeLegalServiceScreen';
import ParalegalServiceScreen from './screens/servicesScreens/ParalegalServiceScreen';

const router = createBrowserRouter([
  {
    path: "/",
    element: <HomeScreen/>,
  },
  {
    path: "/about",
    element: <AboutUsScreen/>,
  },
  {
    path: "/services",
    element: <ServicesScreen/>,
  },
  {
    path: "/services/remote-in-house-counsel",
    element: <RemoveServiceScreen/>,
  },
  {
    path: "/services/contract-drafting-and-management",
    element: <ContractServiceScreen/>,
  },
  {
    path: "/services/corporate-governance-and-compliance",
    element: <CorporateServiceScreen/>,
  },
  {
    path: "/services/intellectual-property-services",
    element: <IPServiceScreen/>,
  },
  {
    path: "/services/litigation-support-and-ediscovery",
    element: <LitigationServiceScreen/>,
  },
  {
    path: "/services/hr-legal-support",
    element: <HRServiceScreen/>,
  },
  {
    path: "/services/data-privacy-and-protection",
    element: <DataPrivacyServiceScreen/>,
  },
  {
    path: "/services/mergers-and-acquisitions-legal-support",
    element: <MergersServiceScreen/>,
  },
  {
    path: "/services/fixed-fee-legal",
    element: <FixedFeeLegalServiceScreen/>,
  },
  {
    path: "/services/paralegal-service",
    element: <ParalegalServiceScreen/>,
  },
  {
    path: "/pricing",
    element: <PricingScreen/>,
  },
  {
    path: "/contact",
    element: <ContactScreen/>,
  },
  {
    path: "/faq",
    element: <FaqScreen/>,
  },
  {
    path: "/privacypolicy",
    element: <PrivacyPolicyScreen/>,
  },
  {
    path: "/terms",
    element: <TermsAndConditionsScreen/>,
  },
  {
    path: "/blogs",
    element: <BlogsScreen/>,
  },
  {
    path: "/blogs/1",
    element: <Blog1Screen/>,
  },
  {
    path: "/blogs/2",
    element: <Blog2Screen/>,
  },
  {
    path: "/blogs/3",
    element: <Blog3Screen/>,
  },
  {
    path: "*",
    element: <NoPage />,
  },
]);


export default function Layout() {

  // const TrackPage = () => {
  //   const location = window.location.name;
  
  //   useEffect(() => {
  //     logPageView();
  //   }, [location]);
  
  //   return null;
  // };
  
  // useEffect(() => {
  //   initGA();
  // }, []);

  return (
    <>
      <Navbar />
      {/* <TrackPage /> */}
      <main>
        {/* Render the router here */}
        <RouterProvider router={router} />
      </main>
      <Footer />
    </>

  );
}
